import { toI18n } from 'util/i18n';

interface CurrentProfile {
  userId: number;
  userFullName: string;
  informationType: string;
  disableBankAccountsOps: boolean;
  moreThanOneCompany: boolean;
  disableBankAccountEditButton?: boolean;
}

// determines if current user has permission to edit a user profile
// returns properties and attributes for the edit button
export const postMergeRequestBankingInformationEditButtonAttrs = (
  currentProfile: CurrentProfile,
  currentUserId: number,
  isPayrollEnrolled = false
) => {
  let disableButton;
  let buttonContent;

  if (
    currentProfile.userId === currentUserId &&
    !currentProfile.disableBankAccountEditButton
  ) {
    disableButton = false;
    buttonContent = null;
  } else if (
    currentProfile.informationType === 'banking' &&
    currentProfile.disableBankAccountEditButton
  ) {
    // prevent users' that are not payroll admin
    // or payroll admins accessed by god mode from editing the banking info
    disableButton = true;
    buttonContent = toI18n(
      'product_usage.hover_text.only_payroll_admins_can_edit_bank_accounts'
    );
  } else if (
    isPayrollEnrolled &&
    currentProfile.informationType === 'banking' &&
    currentProfile.disableBankAccountsOps
  ) {
    // Prevent users from editing bank accounts if they don't have MFA enabled
    disableButton = true;
    buttonContent = toI18n('product_usage.hover_text.mfa_verification_text');
  } else if (
    isPayrollEnrolled &&
    currentProfile.informationType === 'banking' &&
    !currentProfile.disableBankAccountEditButton
  ) {
    // allow payroll admins users to edit the bank account
    // even if the user is in more than one company
    disableButton = false;
  } else {
    // enable edit button for the user if merge request is not pending
    disableButton = false;
    buttonContent = null;
  }
  return { disabled: disableButton, content: buttonContent };
};
